/**
 * Anmeldung pro Browser-Tab.
 *
 * Token und Benutzer lagen bisher nur im localStorage, den sich alle Tabs
 * teilen – meldete man sich in einem zweiten Tab bei einem anderen Mandanten
 * an, arbeitete der erste Tab plötzlich ebenfalls mit diesem Mandanten.
 *
 * Dieses Modul leitet die Anmelde-Schlüssel des localStorage auf den
 * sessionStorage (je Tab) um:
 *   - lesen:     zuerst der Wert dieses Tabs; hat der Tab noch keinen (neu
 *                geöffnet), wird die zuletzt verwendete Anmeldung übernommen
 *   - schreiben: in diesen Tab UND als "zuletzt verwendet" in den localStorage,
 *                damit neue Tabs angemeldet starten
 *   - löschen:   nur in diesem Tab; der localStorage-Wert nur, wenn er noch
 *                zu diesem Tab gehört (Abmelden in Tab B wirft Tab A nicht raus).
 *                Ein abgemeldeter Tab übernimmt danach keine fremde Anmeldung.
 *
 * Muss als erstes Modul geladen werden (siehe index.js), damit sämtliche
 * bestehenden localStorage.getItem('token')-Aufrufe erfasst sind.
 */
const TAB_KEYS = new Set(['token', 'user', 'auth', 'userName']);

function install() {
  if (typeof window === 'undefined' || typeof Storage === 'undefined') return;
  let local;
  let session;
  try {
    local = window.localStorage;
    session = window.sessionStorage;
  } catch {
    return; // Speicher gesperrt (z. B. Privatmodus mit Blockade)
  }
  if (!local || !session || Storage.prototype.__ewTabSession) return;

  const orig = {
    getItem: Storage.prototype.getItem,
    setItem: Storage.prototype.setItem,
    removeItem: Storage.prototype.removeItem,
  };
  const betrifft = (store, key) => store === local && TAB_KEYS.has(String(key));
  const abgemeldet = (key) => `__ew_abgemeldet_${key}`;

  Storage.prototype.getItem = function getItem(key) {
    if (!betrifft(this, key)) return orig.getItem.call(this, key);
    const eigener = orig.getItem.call(session, key);
    if (eigener !== null) return eigener;
    if (orig.getItem.call(session, abgemeldet(key)) !== null) return null;
    const zuletzt = orig.getItem.call(local, key);
    if (zuletzt !== null) {
      try { orig.setItem.call(session, key, zuletzt); } catch { /* voll */ }
    }
    return zuletzt;
  };

  Storage.prototype.setItem = function setItem(key, value) {
    if (!betrifft(this, key)) return orig.setItem.call(this, key, value);
    try {
      orig.setItem.call(session, key, String(value));
      orig.removeItem.call(session, abgemeldet(key));
    } catch { /* voll */ }
    return orig.setItem.call(local, key, value);
  };

  Storage.prototype.removeItem = function removeItem(key) {
    if (!betrifft(this, key)) return orig.removeItem.call(this, key);
    const eigener = orig.getItem.call(session, key);
    orig.removeItem.call(session, key);
    try { orig.setItem.call(session, abgemeldet(key), '1'); } catch { /* voll */ }
    const zuletzt = orig.getItem.call(local, key);
    if (eigener === null || zuletzt === eigener) orig.removeItem.call(local, key);
    return undefined;
  };

  Object.defineProperty(Storage.prototype, '__ewTabSession', { value: true });
}

install();
